import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <span className="font-heading text-xl font-bold text-background-50">泰坦尼克号</span>
          </div>
          <p className="text-sm text-background-200/80 leading-relaxed">
            专注于“泰坦尼克号”主题影视内容的资料站，汇集电影介绍、演员信息、剧情解析与最新资讯，带你重温这段跨越时代的经典传奇。
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-accent-300 mb-4 tracking-wide">
            <a href="#nav-explore" className="cursor-pointer">站点导航</a>
          </h4>
          <ul className="space-y-2 text-sm text-background-200/80">
            <li><Link to="/" className="hover:text-background-50 cursor-pointer whitespace-nowrap">首页</Link></li>
            <li><Link to="/category" className="hover:text-background-50 cursor-pointer whitespace-nowrap">影视分类</Link></li>
            <li><Link to="/news" className="hover:text-background-50 cursor-pointer whitespace-nowrap">资讯专题</Link></li>
            <li><Link to="/about" className="hover:text-background-50 cursor-pointer whitespace-nowrap">关于我们</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-accent-300 mb-4 tracking-wide">
            <a href="#nav-category" className="cursor-pointer">影视分类</a>
          </h4>
          <ul className="space-y-2 text-sm text-background-200/80">
            <li><Link to="/category?type=电影" className="hover:text-background-50 cursor-pointer whitespace-nowrap">电影</Link></li>
            <li><Link to="/category?type=电视剧" className="hover:text-background-50 cursor-pointer whitespace-nowrap">电视剧</Link></li>
            <li><Link to="/category?type=纪录片" className="hover:text-background-50 cursor-pointer whitespace-nowrap">纪录片</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-accent-300 mb-4 tracking-wide">
            <a href="#nav-contact" className="cursor-pointer">联系我们</a>
          </h4>
          <ul className="space-y-2 text-sm text-background-200/80">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line"></i>
              <span>contact@titanic-film.com</span>
            </li>
            <li className="flex items-center gap-3 pt-1">
              <a href="#" aria-label="X" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-accent-500 hover:text-primary-950 cursor-pointer transition-colors">
                <i className="ri-twitter-x-line"></i>
              </a>
              <a href="#" aria-label="Instagram" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-accent-500 hover:text-primary-950 cursor-pointer transition-colors">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" aria-label="Facebook" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-accent-500 hover:text-primary-950 cursor-pointer transition-colors">
                <i className="ri-facebook-line"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-background-300/70">
          <p>© 2026 泰坦尼克号影视档案馆 版权所有</p>
          <p>本站内容为前端演示展示，相关影视资料仅供学习交流使用</p>
        </div>
      </div>
    </footer>
  );
}